import React from 'react'
import { useCallback } from 'sb-hooks'
import actions from 'redux/actions'
import { constants, snowplow } from 'common/helpers'
import type { Events } from 'common/helpers/analytics/snowplow/config'
import type { UnpauseTypes } from 'common/helpers/constants/unpauseTypes'

import { Button } from 'components/_new/controls'
import type { ButtonProps } from 'components/_new/controls'

import messages from './messages'


type UnpauseButtonProps = Partial<Pick<ButtonProps, 'className' | 'size' | 'title' | 'color' | 'fullWidth' | 'dataTestId'>> & {
  placement: Events['Unpause click']['placement']
  unpauseType?: UnpauseTypes
}

const UnpauseButton: React.FunctionComponent<UnpauseButtonProps> = (props) => {
  const {
    className, fullWidth, unpauseType: unpauseCode, placement,
    size = 'md',
    color = 'brand',
    title = messages.title,
    dataTestId = constants.testIds.profile.orderStatusButtons.unpause,
  } = props

  const handleClick = useCallback(() => {
    snowplow.track('Unpause click', { placement }, false)
    actions.models.subscription.unpause({ unpauseCode, placement })
  }, [ unpauseCode, placement ])

  return (
    <Button
      className={className}
      size={size}
      title={title}
      color={color}
      fullWidth={fullWidth}
      dataTestId={dataTestId}
      onClick={handleClick}
    />
  )
}


export default UnpauseButton
